<div class="-menu-asset">
  @if (icon) {
  <lucide-icon [name]="icon" class="menu-item-icon"></lucide-icon>
  }
</div>
<div class="-menu-block">
  <h3>{{name}}</h3>
  <p>{{description}}</p>
</div>
